module.exports = __webpack_public_path__ + "images/favicon-c48a6df187df2a03e48558f6a1ce2847.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/favicons/favicon.jpg
// module id = 16
// module chunks = 0